<template>
    <div class="col-sm-6 col-md-6">
        <h2 style="font-size: 28px;">{{ aboutsundair[getCurrentLocale] }}</h2>
        <p>
            <span v-html="aboutsundairtext[getCurrentLocale]" style="color: #fefe00; font-size: 18px;"></p>
        <br />


        <!-- <h2 style="color: #ec008b;">{{ webshop[getCurrentLocale] }}</h2>
        <ul class="discover triangle hover row">
            <li><a href="/webshop/" >{{ webshoplogin[getCurrentLocale] }}</a></li>
        </ul> -->


        <br /><br /><br />
        <!-- <address class="contact-details">
            <span class="contact-phone">
                <i class="soap-icon-phone"></i> +49 30 53676791</span>
            <br />
            <a href="mailto:kundenservice@sundair.com" class="contact-email">kundenservice@sundair.com</a>
        </address>
        <ul class="social-icons clearfix">
            <li class="facebook">
                <a title="facebook" href="https://www.facebook.com/sundair/" data-toggle="tooltip" target="_new">
                    <i class="soap-icon-facebook"></i>
                </a>
            </li>
            <li class="linkedin">
                <a title="linkedin" href="https://www.linkedin.com/company/sundair" data-toggle="tooltip" target="_new">
                    <i class="soap-icon-linkedin"></i>
                </a>
            </li>
            <li class="webshop">
                <a title="webshop" href="https://webshop.sundair.com" data-toggle="tooltip" target="_new">
                    <i class="soap-icon-flight-hotel"></i>
                </a>
            </li>
        </ul> -->
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                aboutsundair: {
                    en: 'About KAYOFLY',
                    de: 'Über KAYOFLY',
                },
                aboutsundairtext: {
                    en: 'Welcome to <strong>Kayofly</strong>! We are a travel agency in the heart of Berlin and specialized in Tunisia.<br />Would you like to travel to Tunisia, get to know the country or just experience a dream vacation? Or are you a Tunisian yourself and would like to return to your home country?<br />Kayofly is in any case your right contact for your wishes around Tunisia. You have another desired destination? Kayofly also looks for you worldwide the cheapest flights, the most beautiful hotels and the best service around your trip.',
                    de: 'Herzlich willkommen bei <strong>Kayofly</strong>! Wir sind ein Reisebüro mitten im Herzen von Berlin und spezialisiert auf Tunesien.<br />Möchten Sie gerne eine Reise nach Tunesien unternehmen, das Land kennenlernen oder einfach nur einen Traumurlaub erleben? Oder sind Sie selber Tunesier und würden gerne wieder in Ihre Heimat?<br />Kayofly ist in jedem Fall Ihr richtiger Ansprechpartner für Ihre Wünsche rund um Tunesien. Sie haben ein anderes Wunschziel? Kayofly sucht Ihnen auch weltweit die günstigsten Flüge, die schönsten Hotels und den besten Service rund um Ihre Reise.',
                },
                webshop: {
                    en: 'Webshop',
                    de: 'Webshop',
                },
                webshoplogin: {
                    en: 'To the Webshop',
                    de: 'Zum Webshop',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    /* #ec008b */
</style>


// WEBPACK FOOTER //
// src/components/shared/footer/ThirdRow.vue